import { render, staticRenderFns } from "./TheLayoutPortal.vue?vue&type=template&id=fc4c7b20"
import script from "./TheLayoutPortal.vue?vue&type=script&lang=ts"
export * from "./TheLayoutPortal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports